import moment from 'moment';

export default [
	[
		{
			index: 'id',
			header: {
				title: 'id'
			},
			column: {}
		},
		{
			index: 'created_at',
			header: {
				title: 'created at'
			},
			column: {
				format: v => moment(v).format('DD.MM.YYYY HH:mm')
			}
		},
		{
			index: 'campaign_ids',
			header: {
				title: 'campaigns'
			},
			column: {}
		},
		{
			index: 'type',
			header: {
				title: 'type'
			},
			column: {}
		},
		{
			index: 'content',
			header: {
				title: 'content'
			},
			column: {}
		},
		{
			index: 'status',
			header: {
				title: 'status'
			},
			column: {}
		},
		{
			index: 'views',
			header: {
				title: 'views'
			},
			column: {}
		},
		{
			index: 'clicks',
			header: {
				title: 'clicks'
			},
			column: {}
		},
		{
			index: 'actions',
			header: {
				title: 'actions'
			},
			column: {}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/popups/popup/list/table-initial-data.js